<template>
	<!-- 请假 -->
	<div class="qingjiaBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">请假</p>
				</div>
			</div>
		</van-sticky>
		<!-- 请假内容 -->
		<div class="queryQingjiaBox">
			<div class="bookName"><span>文章名：</span><span>{{bookName}}</span></div>
			<div class="qjReasonBox">
				<p class="qjReasonTxt">请假原因：</p>
				<div class="textareaBox">
					<textarea class="site" maxlength="50" @input="descInput" v-model="desc"></textarea>
					<span class="xianzhi">{{remnant}}/50</span>
				</div>
			</div>
			<div class="hgtime">
				<span>回归时间:</span>
				<span>{{timeValue}}<img src="../assets/img/hgtime.png" alt="" @click="showPopFn"></span>
			</div>
			<van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
				<van-datetime-picker v-model="currentDate" type="date" @change="changeFn()" @confirm="confirmFn()" @cancel="cancelFn()" />
			</van-popup>
		</div>
		<div class="submitBtnBox">
			<img src="../assets/img/flower.png" alt="">
			<button class="submitBtn" @click="ask_leave">提交</button>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				desc: '', //文本域内容
				remnant: 0, //开始字数
				msg: '',
				currentDate: new Date(),
				changeDate: new Date(),
				show: false, // 用来显示弹出层
				timeValue: '',
				bookName:'',
			}
		},
		created() {
			this.bookName = this.$route.query.bookName;
			// 电量条
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		mounted() {
			this.timeFormat(new Date());
		},
		methods: {
			showPopFn() {
				this.show = true;
			},
			showPopup() {
				this.show = true;
			},
			changeFn() { // 值变化是触发
				this.changeDate = this.currentDate // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
			},
			confirmFn() { // 确定按钮
				this.timeValue = this.timeFormat(this.currentDate);
				this.show = false;
			},
			cancelFn() {
				this.show = !this.show;
			},
			timeFormat(time) { // 时间格式化 2019-09-08
				let year = time.getFullYear();
				let month = time.getMonth() + 1;
				let day = time.getDate();
				return year + '-' + month + '-' + day
			},
			// 文本域字数限制
			descInput() {
				let txtVal = this.desc.length;
				this.remnant = 0 + txtVal;
			},
			// 请假接口
			ask_leave() {
				this.$axios.post(this.$api.ask_leave,{
					books_id: this.$route.query.book_id,
					back_time: this.timeValue,
					reason: this.desc,
				}).then(res => {
					Toast(res.data.msg)
					this.$router.push('/qingjia')
				})
			},
		}
	}
</script>
<style>
	textarea::placeholder {
		font-size: 28px;
		/*px*/
	}
</style>
<style lang="less" scoped>
	.qingjiaBox {
		height: 100vh;
		background-color: #fff;
		position: relative;
		/deep/.van-picker__toolbar {
			/deep/.van-picker__confirm {
				color: #ff4081 !important;
			}
		}
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						padding-top: 20px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//请假内容	
		.queryQingjiaBox {
			padding: 0 16px;
			background-color: #fff;

			// 文章名
			.bookName {
				// height: 80px;
				line-height: 80px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				span {
					font-size: 32px;
					/*px*/
					padding-right: 20px;
				}
			}

			//文本域
			.qjReasonBox {
				position: relative;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.qjReasonTxt {
					line-height: 80px;
					font-size: 30px;
					/*px*/
				}

				.textareaBox {
					display: inline-block;
					position: relative;
					width: calc(100vw - 32px);

					textarea {
						width: calc(100vw - 32px);
						border: 0;
						height: 180px;
					}

					.xianzhi {
						position: absolute;
						bottom: 0px;
						right: 0px;
						color: #a3a3a3;
						font-size: 32px;
						/*px*/
						background-color: #fff;
					}
				}
			}
		}

		.hgtime {
			line-height: 80px;
			border-bottom: 1px solid #f0f0f0;
			/*no*/
			display: flex;
			font-size: 30px;

			/*px*/
			span:last-child {
				width: 74%;
				text-align: right;
				color: #7f7f7f;
				position: relative;

				img {
					width: 60px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
				}
			}
		}

		//提交
		.submitBtnBox {
			text-align: center;
			position: relative;
			width: 100vw;
			margin-top: 300px;

			img {
				position: absolute;
				top: -60px;
				left: 15%;
				width: 100px;
			}

			.submitBtn {
				width: 90%;
				line-height: 80px;
				color: #fff;
				border: 0;
				border-radius: 10px;
				background-color: #ff4081;
				font-size: 32px;
				/*px*/
			}

		}
	}
</style>
